import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import AssetRequestManagementDetailForm from './AssetRequestManagementDetailForm'
import AssetRequestManagementDetailTable from './AssetRequestManagementDetailTable'
import { doneLoading, startLoading } from '../../utils/loading'
import {
  getAssetRequestManagementDetail,
  getAssetRequestManagementSearchForm,
  getReserveDocumentRequest,
  savehAssetRequestManagementDetail,
  searchAssetRequestManagementSearchForm,
} from '../../redux/actions/assetRequestManagementDetail'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { downloadDurableArticlesFile } from '../../redux/actions/accountingExpenses'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { sessionGetItemObj } from '../../utils/sessionHelpers'

export default function AssetRequestManagementDetailWidgets({ header, isProposalStep, ...props }) {
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [searchFormSchema, setSearchFormSchema] = useState()
  const [dataTableSchema, setDataTableSchema] = useState([])
  const [userRole, setUserRole] = useState(props.userRole)
  const [isEditForProposalStep, setIsEditForProposalStep] = useState(true)

  const projectId = sessionStorage.getItem('projectId')
  const bookingInfo = sessionGetItemObj('bookingInfo')

  useEffect(() => {
    if ((!props.schema?.isApprover && !props.schema.disabled) || isProposalStep) {
      callAssetRequestManagementSearchForm()
    } else {
      setDataTableSchema(props?.schema?.form?.assets || {})
    }
  }, [props.schema])

  const callAssetRequestManagementSearchForm = async () => {
    setIsLoading(true)
    startLoading()

    try {
      var response = await getAssetRequestManagementSearchForm(
        0,
        0,
        bookingInfo.id ? bookingInfo.id : '',
        isProposalStep ? projectId : ''
      )
      console.log('re', response)
      if (response.model) {
        setSearchFormSchema(response?.model?.form?.searchForm)
        setDataTableSchema(response?.model?.form?.result)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const onSearch = async (request) => {
    console.log('onSearch', request)

    setIsLoading(true)
    startLoading()

    try {
      var response = await searchAssetRequestManagementSearchForm(
        request,
        0,
        0,
        bookingInfo.id ? bookingInfo.id : '',
        isProposalStep ? projectId : ''
      )

      if (response.model) {
        setDataTableSchema(response?.model)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      console.log('error ', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSaveApproved = async (request) => {
    console.log('handleSaveApproved ', request)

    setIsLoading(true)
    startLoading()

    try {
      let response = await savehAssetRequestManagementDetail(request)
      console.log('save ', response)
      if (response) {
        notification.open('success', {
          title: 'บันทึกสำเร็จ',
        })

        if (isProposalStep) {
          setIsEditForProposalStep(false)
          handleRequestAssetSchema()
        }
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || 'ไม่สำเร็จ')
      } else {
        setIsError('ไม่สำเร็จ')
      }
    }

    doneLoading()
    setIsLoading(false)
    return true
  }

  const handleRequestAssetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getAssetRequestManagementDetail('', 0, 0, projectId)
      setFormSchema(_schema.model)
    } catch (e) {
      console.log(e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleViewFiles = async (fileName, filePath) => {
    console.log('handleViewFiles ', filePath)

    setIsLoading(true)
    startLoading()
    try {
      var file = await downloadDurableArticlesFile(filePath)

      // downloadFile(file, fileName)
      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetReserveDoc = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const id = bookingInfo.id ? bookingInfo.id : ''

      var file = await getReserveDocumentRequest(id)

      previewFile(file, `แบบฟอร์มขอใช้งานครุภัณฑ์โครงการ_${id}`)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={header || ' '} bordered>
        {!formSchema?.isApprover && searchFormSchema && isEditForProposalStep && (
          <AssetRequestManagementDetailForm
            schema={searchFormSchema}
            onSearch={onSearch}
            loading={isLoading}
          />
        )}

        <AssetRequestManagementDetailTable
          schema={dataTableSchema}
          formSchema={formSchema}
          loading={isLoading}
          onSave={handleSaveApproved}
          isProposalStep={isProposalStep}
          onViewFiles={handleViewFiles}
          isEditForProposalStep={isEditForProposalStep}
          setIsEditForProposalStep={setIsEditForProposalStep}
          onPreview={handleGetReserveDoc}
        />
      </Panel>
    </>
  )
}
